<template>
  <BaseModal :isOpen="isOpen" maxWidth="md" @close="closeModal">
    <!-- Icon and Header -->
    <div
      class="flex flex-col items-center text-center sm:flex-row sm:text-left"
    >
      <div
        class="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-red-50 to-red-100 ring-4 ring-red-50"
      >
        <svg
          aria-hidden="true"
          class="h-7 w-7 text-red-600"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
      </div>
      <div class="mt-4 sm:ml-5 sm:mt-0">
        <h2 class="text-xl font-bold leading-6 text-gray-900 sm:text-2xl">
          {{ titleText }}
        </h2>
        <p class="mt-3 text-sm leading-5 text-gray-600 sm:text-base">
          {{ deleteMessage }}
        </p>
      </div>
    </div>

    <!-- Action Buttons -->
    <div
      class="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end sm:gap-3"
    >
      <button
        class="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-5 py-3 text-sm font-semibold text-gray-700 shadow-sm transition-all hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 active:bg-gray-100"
        type="button"
        @click="closeModal"
      >
        Cancel
      </button>
      <button
        class="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-red-600 to-red-700 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-red-500/30 transition-all hover:from-red-700 hover:to-red-800 hover:shadow-xl hover:shadow-red-500/40 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 active:scale-[0.98]"
        type="button"
        @click="confirmDelete"
      >
        Delete
      </button>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/ui/BaseModal.vue";

export default {
  components: {
    BaseModal,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    deleteMessage: {
      type: String,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    confirmDelete() {
      this.$emit("confirm");
      this.$emit("close");
    },
  },
};
</script>
